export default __webpack_public_path__ + "static/media/79_mobile.49ebb149.jpg";